export default "__VITE_ASSET__625baa26__"